/**
 * PROPRIETARY AND CONFIDENTIAL
 * Copyright © 2026 Contractor Co-Pilot. All Rights Reserved.
 */

"use client";

import { FadeIn } from "./primitives/fade-in";
import { StatCounter } from "./primitives";
import {
  TRADES_COUNT,
  AI_TOOL_COUNT,
  FREE_TRIAL_DAYS,
} from "@/content/landing/constants";

const stats = [
  { value: TRADES_COUNT, suffix: "", label: "trades pre-loaded with costs" },
  { value: AI_TOOL_COUNT, suffix: "", label: "AI assistant tools" },
  { value: FREE_TRIAL_DAYS, suffix: "", label: "days free on every plan" },
];

export function TrustBarSection() {
  return (
    <section
      className="bg-background-warm-alt border-y border-border/40 py-5"
      aria-label="Key metrics"
    >
      <div className="max-w-[1280px] mx-auto px-4 md:px-8 lg:px-20">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 sm:gap-8">
          {stats.map((stat, i) => (
            <FadeIn
              key={stat.label}
              className="flex items-center gap-2 text-center sm:text-left"
              delay={i * 80}
              margin="-30px"
            >
              <span className="text-2xl font-bold text-foreground tabular-nums">
                <StatCounter value={stat.value} suffix={stat.suffix} />
              </span>
              <span className="text-sm text-muted-foreground">
                {stat.label}
              </span>
            </FadeIn>
          ))}
          <div className="hidden sm:block w-px h-6 bg-border/50" />
          <p className="text-xs text-muted-foreground tracking-wide">
            Scope &rarr; Estimate &rarr; Proposal &rarr; Project &rarr; Invoice
            &mdash; one connected flow
          </p>
        </div>
      </div>
    </section>
  );
}
